<template>
  <h2 class="sub-title">
    <slot />
  </h2>
</template>

<style scoped>
.sub-title {
  font-size: var(--font-size-18px);
  /* boldのみ */
  font-weight: var(--font-weight-medium);
}
</style>
